import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IContactApiResponse } from "../../../types/api/contact";
import { QData } from "../../../types/basic-type-list";

export async function listContactForms(
  qData: QData,
  formType: "CONTACT" | "ENQUIRY",
): Promise<AxiosResponse<TResponse<IContactApiResponse[]>>> {
  return axios.get(`${API_ENDPOINTS.LIST_CONTACT}/${formType}`, {
    params: qData,
  });
}

export async function deleteContactForms(
  id: string,
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post(API_ENDPOINTS.DELETE_CONTACT, {id});
}
